<template>
  <div class = "toolbar">

    <!-- toolbar mobile -->
    <div v-if = "editorConfig.isMobile" class = "toolbar-container">
      <div class = "left">
        <router-link class = "logo btn btn-bg-transparent" :to="{ name: 'Home', params: {} }">
          <img src = "/static/img/pglp_logo2.png" />
        </router-link>
        <button v-on:click = "showSideMenu" class = "btn btn-bg-transparent btn-left-icon">Menú</button>
      </div>

      <div class = "center">
        <div class = "content" v-if = "projectType && !isInHome">
          <img v-if = "false" :src = "project.cover"/>
          <button class = "btn btn-bg-transparent btn-right-icon" :class = "{ 'not-clickable': !isWritable }" v-on:click = "showSettings" >
             <span id = "project-name-wrapper">
              <span id = "project-name">
                {{project.name}}
              </span>
              <span class="is-size-7 no-editable" v-if="!isWritable">(no editable)</span>
            </span>
            <span v-if = "!editorConfig.isMobile" id = "icon" class = "material-icons md-24">settings</span>
          </button>
        </div>
      </div>

      <div class = "right">
        <auth-menu></auth-menu>
      </div>
    </div>

    <!-- toolbar normal -->
    <div v-else class = "toolbar-container">
      <div class = "left">
        <router-link class = "logo" :to="{ name: 'Home', params: {} }">
          <img src = "/static/img/pglp_logo2.png" />
        </router-link>

        <!--
        <span class = "location">{{$route.name}}</span>
        -->

        <!--
        <router-link class = "btn btn-bg-transparent" :to="{ name: 'Editor', params: {} }"><span :class = "{ selected: $route.name === 'Editor' }">Editor</span></router-link>
        -->
        <router-link v-if = "isAuthenticated" class = "btn btn-bg-transparent" :to="{ name: 'User', params: {} }" :class = "{ disabled: $route.name.includes('User') }" >Mis proyectos</router-link>
        <router-link v-else class = "btn btn-bg-transparent" :to="{ name: 'Editor.create', params: {} }">Crear proyecto</router-link>

        <b-dropdown v-if = "project.config && isInEditor || isInUser">
          <button class="btn" slot="trigger">
            <span>Ejemplos</span>
            <b-icon icon="menu-down"></b-icon>
          </button>

          <div class="dropdown-content">
            <div>
              <div class="dropdown-item explanation">
                <p>Se abrirán en una nueva pestaña</p>
              </div>

              <div class = "group" v-for = "(ex, n) in examples" :key = "n">
                <p class = "dropdown-item header">{{n}}</p>
                <router-link
                  v-for = "e in ex.examples"
                  :key = "e"
                  class = "dropdown-item"
                  :to="{ name: 'Editor.example', params: { exampleType: n, exampleId: e.id }}"
                  target="_blank">
                  {{e.name}}
                </router-link>
              </div>

            </div>
          </div>
         </b-dropdown>
      </div>

      <div class = "center">
        <div class = "content" v-if = "isInEditor">
          <img v-if = "false" :src = "project.cover"/>
          <button class = "btn btn-bg-transparent btn-right-icon" :class = "{ 'not-clickable': !isSettingsEnabled }" v-on:click = "showSettings" >
             <span id = "project-name-wrapper">
              <span id = "project-name">
                {{project.name}}
              </span>
              <span class="is-size-7 no-editable" v-if="!isWritable">(no editable)</span>
            </span>
            <span v-if = "!editorConfig.isMobile" id = "icon" class = "material-icons md-24">settings</span>
          </button>
        </div>
      </div>

      <div class = "right">
        <router-link class = "btn btn-bg-transparent" :to="{ name: 'Gallery', params: { page: 1 } }" target="_blank">Galería</router-link>
        <router-link class = "btn btn-bg-transparent" :to="{ name: 'Recursos', params: {} }" target="_blank"> Recursos </router-link>

        <button v-if="isSubmitable && !editorConfig.isMobile && isInEditor" class = "btn btn-bg-colored btn-right-icon enviar" v-on:click = "showSubmit">
          <span> Terminar</span>
          <span id = "icon" class = "material-icons md-24">send</span>
        </button>
        <!--
        <button class = "btn btn-bg-transparent" v-on:click = "showHelp">Ayuda</button>
        -->
        <auth-menu></auth-menu>
      </div>
    </div>

  </div>
</template>

<script>
import AuthMenu from '../User/AuthMenu'

export default {
  name: 'Toolbar',
  components: {
    AuthMenu
  },
  props: {
  },
  computed: {
    project () {
      return this.$store.state.project
    },
    projectType () {
      console.log(this.project)
      if (this._.isEmpty(this.project)) {
        return null
      } else {
        return this.project.config.type
      }
    },
    editorConfig () {
      return this.$store.state.editorConfig
    },
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    isUserAdmin () {
      return this.$store.getters.getIsUserAdmin
    },
    isWritable () {
      return this.$store.getters.getIsProjectWritable
    },
    isSettingsEnabled () {
      if (this.isUserAdmin) return true
      else return this.isWritable
    },
    isForkable () {
      return this.$store.getters.getIsProjectForkable
    },
    isCloneable () {
      return this.$store.getters.getIsProjectCloneable
    },
    isExample () {
      return this.$store.getters.getIsProjectExample
    },
    isSubmitable () {
      return this.$store.getters.getIsProjectSubmitable
    },
    examples: function () {
      return this.$store.state.examples
    },
    isInHome: function () {
      return this.$route.name === 'Home' || this.$route.name === 'Gallery' || this.$route.name === 'Recursos'
    },
    isInEditor: function () {
      return this.$route.name === 'Editor' || this.$route.name === 'Editor.create' || this.$route.name === 'Editor.created' || this.$route.name === 'Editor.example' || this.$route.name === 'Editor.load'
    },
    isInUser: function () {
      return this.$route.name === 'User'
    },
    isInUserSettings: function () {
      return this.$route.name === 'usersettings'
    },
    isInSketchPlayer: function () {
      return this.$route.name === 'ProjectPlayer'
    }
  },
  methods: {
    showSubmit: function () {
      console.log('showSubmit')
      this.$store.commit('setEditorConfigProperty', {'isShowingSubmit': true})
    },
    showSideMenu: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingSideMenu': true})
    },
    hideSideMenu: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingSideMenu': false})
    },
    showSettings: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingSettings': true})
    },
    showHelp: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingHelp': true})
    },
    saveProject: function () {
      this.$store.dispatch('handleSaveProject')
    }
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.toolbar {
  background: @accentColor;
  width: 100%;

  .toolbar-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 58px;
  }

  .btn {
    height: 58px;
  }
}

.left, .center, .right {
  display: flex;
  align-items: center;
}

.left {
  .logo {
    // background: #ea5ce3;
    width: 58px;
    justify-content: center;
    padding: 10px;
    img { }
  }

  .selected {
    border-bottom: 2px solid #323232;
  }

  .location {
    font-family: 'Share Tech', monospace;
    font-weight: 500;
    font-size: 1.2em;
    color: #323232;
    padding: 8px 10px;
    padding-right: 20px;
    margin: 5px;
    border-right: 1px solid #0000001c;
  }
}

.center {
  color: @primaryTextColor;
  justify-content: center;

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  img {
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }

  .not-clickable {
    pointer-events: none;

    #icon {
      display: none;
    }
  }

  #project-name-wrapper {
    position: relative;

    #project-name {
      min-width: 92px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 20ch;
    }

    .no-editable {
      color: #0009;
      position: absolute;
      bottom: -11px;
      width: 100%;
      text-align: center;
      left: 0;
    }
  }
}

.explanation {
  pointer-events: none;
}

.left, .right {
  flex: 1;
}

.right {
  justify-content: flex-end;
}

.btn {
  display: flex;
  align-items: center;
}

.enviar {
  background: white;
  border-radius: 100px;
  height: unset !important;
}

.file-menu {
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/UI/Toolbar.vue